import React from "react";
import $ from "jquery";
import Page from "../Page";
import { API_COURSE_SURVEY, API_SURVEY_TRAINING, API_DETAIL_PROFILE } from "../Util";
import { Row, Col, Input, Button, Modal } from "react-materialize";
import { notify } from "react-notify-toast";
import "../../styles/surveiTraining.css";

class SurveiTraining extends Page {
	constructor(props) {
		super(props);
		this.state = {
			width:800,
			dateFormType: "text",
			autoCompleteVisibility: {
				province: false,
				city: false,
				course: false,
			},
			autoCompleteActive: {
				province: false,
				city: false,
				course: false,
			},
			startEditDomisili: false,
			pointer: {
				province: 0,
				city: 0,
				course:0,
			},
			startPointer: false,
			coursesData: [],
			coursesData_filtered: [],
         userData:"",
			formData: {
				name: "",
				email: "",
				course:"",
				course_id: "",
				question: [
					{ id: "1", answer: "" },
					{ id: "2", answer: "" },
					{ id: "3", answer: "" },
					{ id: "4", answer: "" },
					{ id: "5", answer: "" },
					{ id: "6", answer: "" },
				],
				comment: "",
			},
			formErrors: {
				errorFullname: "",
				errorEmail: "",
				errorCourse: "",
				errorQuestion: [
					{ id: "1", message: "" },
					{ id: "2", message: "" },
					{ id: "3", message: "" },
					{ id: "4", message: "" },
					{ id: "5", message: "" },
					{ id: "6", message: "" },
				],
            errorComment:""
			},
			isSubmit:"",
         current_section: 1
		};

		this.regexFullname = RegExp(/^[A-Za-z ]+$/);
		this.regexDate = RegExp(
			/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/,
		);
		this.clientToken = "aa6d8694eea3d1b52aa6e4169b0a822665b56fc4";
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions);
		this.loadCoursesData();
      this.loadUserData();
	}

	componentWillMount = function () {
		this.updateDimensions();
	};

	componentWillUnmount = function () {
		window.removeEventListener("resize", this.updateDimensions);
	};

	updateDimensions = () => {
		this.setState({ width: $(window).width(), height: $(window).height() });
	};

   selectCourse = (e, course) => {
		if (typeof course != "undefined") {
			let formData = this.state.formData;
			formData.course = course.title;
			formData.course_id = course.uuid;

			this.setState({
				autoCompleteVisibility: {
					province: false,
					course: false,
				},
			});
		}
	};

	loadCoursesData = () => {
		$.getJSON(API_COURSE_SURVEY).then((data) => {
			this.setState({
				coursesData: data.payload,
			});
		});
	};

   loadUserData = () => {
      $.post(API_DETAIL_PROFILE).then(data => {
         this.state.formData.name = data.payload.data[0].name
         this.state.formData.email = data.payload.data[0].email
			// this.setState({ userData: data.payload.data[0] });
		});
   }

	loadCoursesData_filtered = (keyword) => {
		let result = this.state.coursesData.filter((course) =>
			course.title.toLowerCase().includes(keyword.toLowerCase()),
		);

		this.setState({ coursesData_filtered: result });
	};

	handleFocus = (type, state) => {
		let { autoCompleteVisibility } = this.state;
		
		autoCompleteVisibility[type] = state;

		this.setState({ autoCompleteVisibility });

		if (!this.state.formData[type]) {
			if(type=='course'){
				this.setState({ coursesData_filtered: this.state.coursesData });
			}else{
				this.setState({ provincesData_filtered: this.state.provincesData });
			}
		}
	};

	handleChange = (e) => {
		let { value, name } = e.target;
		let { formData } = this.state;

		switch (name) {
			case "fullname":
				formData.name = value;
				break;
			case "email":
				formData.email = value;
				break;
			case "provinsi":
				formData.province = value;
				this.loadProvincesData_filtered(value);
				this.setState({
					autoCompleteVisibility: {
						province: true,
						city: false,
					},
				});
				this.state.pointer.province = 0;
				break;
			case "pelajaran":
				formData.course = value;
				this.loadCoursesData_filtered(value);
				this.setState({
					autoCompleteVisibility: {
						province: false,
						course: true,
					},
				});
				this.state.pointer.course = 0;
				break;
			case "question_1":
				formData.question[0].answer = value;
				break;
			case "question_2":
				formData.question[1].answer = value;
				break;
			case "question_3":
				formData.question[2].answer = value;
				break;
			case "question_4":
				formData.question[3].answer = value;
				break;
			case "question_5":
				formData.question[4].answer = value;
				break;
			case "question_6":
				formData.question[5].answer = value;
				break;
			// case "comment":
			// 	formData.comment = value;
			// 	break;
			default:
				break;
		}

		this.setState({ formData });
	};

	handleSubmit = async (e) => {
		e.preventDefault();
      let formData = this.state.formData;

      this.handleUpdate(formData);
		// if (this.checkIsFormValid()) {
		// }
	};

	checkInputValidity = (array, data) => {
		return array.find((item) => item == data) ? true : false;
	};

	checkCourse = (array, data) => {
		return array.find((item) => item.title == data) ? true : false;
	};

	ArrowKeySelectCourse = (e) => {
		this.state.startPointer = true;

		let pointer = this.state.pointer;

		if (e.keyCode == "38") {
			if (pointer.course > 0) {
				pointer.course--;
			}

			if (pointer.course > 5) {
				let position = $(".autocomplete-list").scrollTop();
				$(".autocomplete-list").scrollTop(position - 36);
			}

			this.setState({ pointer });
		} else if (e.keyCode == "40") {
			if (pointer.course > 5) {
				let position = $(".autocomplete-list").scrollTop();
				$(".autocomplete-list").scrollTop(position + 36);
			}

			if (pointer.course < this.state.coursesData_filtered.length - 1) {
				pointer.course++;
			}
			this.setState({ pointer });
		} else if (e.keyCode == "13") {
			e.preventDefault();
			this.handleAutocompleteBlur("course");
		}

		if (
			this.state.coursesData_filtered.length &&
			typeof this.state.coursesData_filtered[pointer.course] !=
				"undefined"
		) {
			this.state.formData.course =
				this.state.coursesData_filtered[pointer.course].title;
			this.state.formData.course_id =
				this.state.coursesData_filtered[pointer.course].uuid;
		}
	};

	checkIsFormValid = (current_section) => {
		let formData = this.state.formData;
		let { formErrors } = this.state;
		let isValid = true;

      // Fullname Validation
      if (!formData.name) {
         formErrors.errorFullname = "Nama tidak boleh kosong";
      } else {
         formErrors.errorFullname = "";
      }

      // Email Validation
      if (!formData.email) {
         formErrors.errorEmail = "Email tidak boleh kosong";
      } else if (!formData.email || !formData.email.includes("@")) {
         formErrors.errorEmail = "Email yang anda masukkan tidak valid";
      } else {
         formErrors.errorEmail = "";
      }

      // topic Validation
      if (!formData.course) {
         formErrors.errorCourse = "Topik Pelatihan tidak boleh kosong";
      } else if (
         !this.checkCourse(
            this.state.coursesData,
            formData.course,
         )
      ) {
         formErrors.errorCourse =
            "Topik Pelatihan tidak valid. Harap pilih dari list yang sudah disediakan";
      } else {
         formErrors.errorCourse = "";
      }

      if(!formData.question[0].answer){
         formErrors.errorQuestion[0].message = 'question harus di isi';
      }else{
         formErrors.errorQuestion[0].message = '';
      }

      if(!formData.question[1].answer){
         formErrors.errorQuestion[1].message = 'question harus di isi';
      }else{
         formErrors.errorQuestion[1].message = '';
      }

      if(!formData.question[2].answer){
         formErrors.errorQuestion[2].message = 'question harus di isi';
      }else{
         formErrors.errorQuestion[2].message = '';
      }

      if(!formData.question[3].answer){
         formErrors.errorQuestion[3].message = 'question harus di isi';
      }else{
         formErrors.errorQuestion[3].message = '';
      }

      if(!formData.question[4].answer){
         formErrors.errorQuestion[4].message = 'question harus di isi';
      }else{
         formErrors.errorQuestion[4].message = '';
      }
      
      if(!formData.question[5].answer){
         formErrors.errorQuestion[5].message = 'question harus di isi';
      }else{
         formErrors.errorQuestion[5].message = '';
      }

      // if(!formData.comment){
      //    formErrors.errorComment = "Komentar tidak boleh kosong";
      // } else {
      //    formErrors.errorComment = "";
      // }

      this.setState({ formErrors });
		
		// RETURN ISVALID
		Object.values(formErrors).forEach((value) => {
			if(typeof value=="string"){
				if (value) {
					this.setState;
					isValid = false;
				}
			}else{
				value.forEach((err)=>{
					if (err.message) {
						this.setState;
						isValid = false;
					}	
				})
			}
		});
      for(let key in formData) {
         console.log("cek formdata", formData['question']);
         if(formData['question']){
            for(let i in formData['question']){
               if(formData[key] && formData['question'][i].answer){
                  document.querySelector(".btn-modal").click()
               }
            }
         }
      }
		return isValid;
	};

	handleAutocompleteBlur = (type) => {
		if (this.state.startPointer) {
			if (type == "province") {
				this.selectProvince(
					this.state.provincesData_filtered[
						this.state.pointer.province
					],
				);
			} else if (type == "course") {
				this.selectCourse(
					this.state.coursesData_filtered[
						this.state.pointer.course
					],
				);
			}

			this.state.startPointer = false;
		}

		let { autoCompleteVisibility } = this.state;

		if (this.state.autoCompleteActive[type] == false) {
			autoCompleteVisibility[type] = false;

			this.setState({ autoCompleteVisibility: autoCompleteVisibility });
		}
	};

	handleAutoCompleteActive = (type, state) => {
		let { autoCompleteActive } = this.state;
		autoCompleteActive[type] = state;

		this.setState({ autoCompleteActive });
	};

	handleUpdate = (params) => {
		$.post(API_SURVEY_TRAINING, params)
			.then((data) => {
				if (data.payload) {
					this.state.isSubmit = true
					$("#btn-notification-success").trigger("click");
					setTimeout(function () {
                  window.location.reload();
               }, 2000);
					} else {
						this.state.isSubmit = false
					$("#btn-notification-failed").trigger("click");
				}
			})
			.fail((XMLHttpRequest, textStatus, errorThrown) => {
				let response;

				try {
					response = JSON.parse(XMLHttpRequest.responseText);
				} catch (e) {}

				if (response && response.status) {
					if (response.errors) {
						notify.show(response.errors.email[0], "warning");
					} else {
						notify.show(response.message, "warning");
					}
				}
			});
	};

   nextSection = (e) => {
      e.preventDefault()
      if (this.checkIsFormValid(this.state.current_section)){
         let update_section = this.state.current_section + 1
         this.setState({
            current_section: update_section
         })
      }
   }

   previousSection = (e) => {
      e.preventDefault()
      if(this.state.current_section == 3){
         this.state.formData.question[0].answer = ""
         this.state.formData.question[1].answer = ""
         this.state.formData.question[2].answer = ""
         this.state.formData.question[3].answer = ""
         this.state.formData.question[4].answer = ""
         this.state.formData.question[5].answer = ""
      }
      if(this.state.current_section == 2){
         this.state.formErrors.errorQuestion[0].message = ""
         this.state.formErrors.errorQuestion[1].message = ""
         this.state.formErrors.errorQuestion[2].message = ""
         this.state.formErrors.errorQuestion[3].message = ""
         this.state.formErrors.errorQuestion[4].message = ""
         this.state.formErrors.errorQuestion[5].message = ""
      }
      let update_section = this.state.current_section - 1
      this.setState({
         current_section: update_section
      })
   }

	render() {
		var isMobile = this.state.width && this.state.width < 991.98;
		let formData = this.state.formData;
		let formErrors = this.state.formErrors;

		return (
			<div>
				<div className="survey-header">
					<div className={(isMobile)?"survey-container-mobile":""}>
						<Row  className={(isMobile)?"mb-0 align-items-center hidden":"mb-0 align-items-center"}>
							<Col l={12}>
								<div>
									<img
										src={ require("../../assets/survey-img/BANNER-WEBSITE Survey-GETI.png") }
										className="survey-banner"
									></img>
								</div>
							</Col>
						</Row>
						<Row  className={(isMobile)?"mb-0 align-items-center":"mb-0 align-items-center hidden"}>
                     <Col l={12}>
								<div>
									<img
										src={ require("../../assets/survey-img/BANNER-WEBSITE Survey-GETI.png") }
										className="survey-banner"
									></img>
								</div>
							</Col>
						</Row>
					</div>
				</div>
				<div className={(isMobile)?"survey-body-mobile":"survey-body"}>
                  <div className="container">
                     {/* Nama Lengkap */}
                     <h5 className="text-section">DATA DIRI PESERTA</h5>
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p style={{ marginBottom:'0' }}>Nama Lengkap Anda</p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <input
                              style={{ marginBottom:'0' }}
                              name="fullname"
                              placeholder="Masukkan Nama Lengkap Anda"
                              type="text"
                              onChange={this.handleChange}
                              value={formData.name}
                              disabled
                           />
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorFullname}
                           </div>
                        </Col>
                     </Row>

                     {/* Email */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p style={{ marginBottom:'0', marginTop:'30px' }}>Alamat Email Anda</p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <input
                              style={{ marginBottom:'0' }}
                              name="email"
                              placeholder="Masukkan Alamat Email Anda"
                              type="email"
                              onChange={this.handleChange}
                              value={formData.email}
                              disabled
                           />
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorEmail}
                           </div>
                        </Col>
                     </Row>

                     {/* Course */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p style={{ marginBottom:'0', marginTop:'30px' }}>Topik Pelatihan yang Anda Ikuti</p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <input
                              style={{ marginBottom:'0' }}
                              name="pelajaran"
                              type="text"
                              placeholder="Masukkan Kelas yang Anda Ikuti"
                              onBlur={() =>
                                 this.handleAutocompleteBlur("course")
                              }
                              onChange={this.handleChange}
                              onFocus={() =>
                                 this.handleFocus("course", true)
                              }
                              onKeyDown={this.ArrowKeySelectCourse}
                              value={formData.course}
                              className="autocomplete-form"
                              autoComplete="off"
                              disabled={
                                 this.state.coursesData.length
                                    ? false
                                    : true
                              }
                           />
                           <div className="autocomplete-form position-relative">
                              <div
                                 className={
                                    (this.state.autoCompleteVisibility
                                       .course == true
                                       ? ""
                                       : "autocomplete-none") +
                                    " autocomplete-container"
                                 }
                              >
                                 <ul
                                    className="autocomplete-list width-100"
                                    onMouseEnter={() =>
                                       this.handleAutoCompleteActive(
                                          "course",
                                          true,
                                       )
                                    }
                                    onMouseLeave={() =>
                                       this.handleAutoCompleteActive(
                                          "course",
                                          false,
                                       )
                                    }
                                 >
                                    {this.state.coursesData_filtered.map(
                                       (item, index) => (
                                          <li
                                             className={
                                                "autocomplete-item" +
                                                (index ==
                                                this.state.pointer
                                                   .course
                                                   ? " active"
                                                   : "")
                                             }
                                             onClick={(e) =>
                                                this.selectCourse(
                                                   e,
                                                   item,
                                                )
                                             }
                                          >
                                             {item.title}
                                          </li>
                                       ),
                                    )}
                                 </ul>
                              </div>
                              <div className="helper-text text-danger inline-block font-tiny">
                                 {formErrors.errorCourse}
                              </div>
                           </div>
                        </Col>
                     </Row>
                     <h5 className="text-section">Kuesioner</h5>
                        <img 
                           src={ require("../../assets/survey-img/survey-kuisioner.png") }
                           style={{ width:'100vh' }} 
                           alt="" 
                        />
                     <h5 className="text-section">MATERI PELATIHAN</h5>
                     {/* Question 1 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Materi pelatihan sesuai dengan kebutuhan peserta
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_1"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_1"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_1"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_1"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_1"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_1"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_1"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                           
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[0].message}
                           </div>
                        </Col>
                     </Row>

                     {/* Question 2 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Materi pelatihan dapat diterima dan diterapkan dengan mudah
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_2"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_2"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_2"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_2"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_2"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_2"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_2"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[1].message}
                           </div>
                        </Col>
                     </Row>

                     {/* Question 3 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Materi pelatihan disampaikan dengan urut dan sistematikanya jelas
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_3"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_3"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_3"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_3"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_3"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_3"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_3"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[2].message}
                           </div>
                        </Col>
                     </Row>
                     <h5 className="text-section">NARASUMBER</h5>
                     {/* Question 4 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Narasumber menguasai materi yang disampaikan
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_4"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_4"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_4"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_4"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_4"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_4"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_4"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[3].message}
                           </div>
                        </Col>
                     </Row>
                     
                      {/* Question 5 */}
                      <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Narasumber menyajikan materinya dengan jelas dan berurutan
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_5"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_5"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_5"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_5"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_5"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_5"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_5"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[5].message}
                           </div>
                        </Col>
                     </Row>

                     {/* Question 6 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Narasumber berinteraksi dengan peserta
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_6"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_6"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_6"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_6"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_6"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_6"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_6"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[4].message}
                           </div>
                        </Col>
                     </Row>

                     <h5 className="text-section">SARANA & PRASARANA</h5>
                     {/* Question 7 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Fitur di Learning Management System (LMS) kerjalestari.id mudah digunakan
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_7"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_7"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_7"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_7"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_7"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_7"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_7"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[3].message}
                           </div>
                        </Col>
                     </Row>

                     {/* Question 8 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Aplikasi room webinar mudah dioperasikan
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_8"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_8"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_8"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_8"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_8"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_8"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_8"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[3].message}
                           </div>
                        </Col>
                     </Row>
                     
                     {/* Question 9 */}
                     <Row>
                        <Col s={12} m={12} l={12}>
                           <p>
                              Aplikasi room webinar layak digunakan untuk pelaksanaan pelatihan
                           </p>
                        </Col>
                        <Col
                           s={12}
                           m={12}
                           l={12}
                           style={{ display: "flex" }}
                        >
                           <p style={{ marginRight: "10px" }}>
                              Sangat Buruk
                           </p>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1
                              </div>
                              <Input
                                 name="question_9"
                                 type="radio"
                                 className="with-gap"
                                 value="1"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 1.5
                              </div>
                              <Input
                                 name="question_9"
                                 type="radio"
                                 className="with-gap"
                                 value="1.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2
                              </div>
                              <Input
                                 name="question_9"
                                 type="radio"
                                 className="with-gap"
                                 value="2"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 2.5
                              </div>
                              <Input
                                 name="question_9"
                                 type="radio"
                                 className="with-gap"
                                 value="2.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3
                              </div>
                              <Input
                                 name="question_9"
                                 type="radio"
                                 className="with-gap"
                                 value="3"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 3.5
                              </div>
                              <Input
                                 name="question_9"
                                 type="radio"
                                 className="with-gap"
                                 value="3.5"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <div className="question">
                              <div style={{
                                    display: "flex",
                                    justifyContent: "center"
                                 }}
                              >
                                 4
                              </div>
                              <Input
                                 name="question_9"
                                 type="radio"
                                 className="with-gap"
                                 value="4"
                                 onChange={this.handleChange}
                              />
                           </div>
                           <p style={{ marginLeft: "10px" }}>
                              Sangat Baik
                           </p>
                        </Col>
                        <Col s={12} m={12} l={12}>
                           <div className="helper-text text-danger inline-block font-tiny">
                              {formErrors.errorQuestion[3].message}
                           </div>
                        </Col>
                     </Row>

                     <Row className="mt-s mb-s">
                        <div>
                           <Button onClick={this.checkIsFormValid} className="btn-small next-btn">Simpan</Button>
                           <Modal
                              trigger={
                                 <button className="btn-modal" style={{ display:'none' }}>modal</button>
                              }
                           >
                              <div className="center">
                                 <div>
                                    <h5>Apakah Anda yakin ingin simpan survei ini?</h5>
                                 </div>
                                 <div className="d-flex-jc-center">
                                    <button onClick={this.handleSubmit} className="btn btn-small delete-btn mr-xs modal-close">Ya</button>
                                    <button className="btn btn-small delete-btn bg-danger modal-close">Batal</button>
                                 </div>
                              </div>
                           </Modal>
                           {/* <Button
                              className="btn-small next-btn"
                              onClick={this.handleSubmit}
                           >
                              Simpan
                           </Button> */}
                        </div>
                     </Row>
                  </div>
				</div>
					<Modal trigger={<Button className="hide" id="btn-notification-success" />}>
						<div className="center almost-full">
							<h5 className="mb-m" style={{ lineHeight:"2" }}> Terima kasih telah mengisi data survey pelatihan <br/> Penilaian Anda sangat berharga bagi kami </h5>
							<div>
								<Button className="btn modal-close">
										OKE 
								</Button>
							</div>
						</div>
					</Modal>
					<Modal trigger={<Button className="hide" id="btn-notification-failed" />}>
						<div className="center almost-full">
							<h5 className="text-center" style={{ lineHeight:"2" }}>Terdapat kesalahan! <br /> silakan coba lagi</h5>
							<div>
								<Button style={{ backgroundColor:"red" }} className="btn modal-close">
										OKE 
								</Button>
							</div>
						</div>							
					</Modal>
			</div>
		);
	}
}

export default SurveiTraining;



// WEBPACK FOOTER //
// ./src/components/Public/SurveiTraining.js